import React from "react";
import { toElementProps } from "../../Element";
import useLoremIpsum from "../technical/useLoremIpsum.jsx";

export function MenuLinksStyles(params = {}) {
    const { MobileBreakpoint } = params;

    return {
        "& .menu-links:not(.mobile)": {
            display: "grid",
            gridAutoFlow: "column",
            justifyContent: "flex-end",
            gridGap: "32px",

            [MobileBreakpoint]: {
                display: "none",
            },

            "& .menu-link": {
                border: "none",
                background: "none",

                color: "inherit",
                cursor: "pointer",

                textDecoration: "none",

                transition: "all 250ms ease",

                "&:hover": {
                    textDecoration: "underline",
                },
            },
        },

        "& .menu-links.mobile": {
            display: "flex",
            gridGap: "32px",
            flexDirection: "column",
            alignItems: "flex-start",

            "& .menu-link": {
                border: "none",
                background: "none",

                color: "inherit",
                cursor: "pointer",

                textDecoration: "none",

                transition: "all 250ms ease",

                "&:hover": {
                    textDecoration: "underline",
                },
            },
        },
    };
}

export default function MenuLinks(props) {
    const { blocks } = props.variables;
    const { MenuLinkTitle, ProductType, variables2block } = props.variables;

    const LI = useLoremIpsum();

    const textsById = {};
    // From variables
    if (MenuLinkTitle) {
        for (const [key, text] of Object.entries(MenuLinkTitle ?? {})) {
            textsById[key] = text;
        }
    }

    // By Lorem ipsum
    for (const { id, text } of LI.MenuLinks) {
        !textsById[id] && (textsById[id] = text);
    }

    if (!Array.isArray(blocks)) {
        console.warn("Blocks is not array!");
        return null;
    }

    // Complete
    const links = blocks?.map((name, index) => {
        const [nameWithoutIndex, linkIndex] = name.split("-");
        const href = linkIndex ? `#${nameWithoutIndex}${linkIndex}` : `#${nameWithoutIndex}`;

        let linkText = textsById[nameWithoutIndex];

        if (ProductType === "Custom") {
            const customBlocksMenuLinkTitles = variables2block[index + 1].variables.MenuLinkTitle;

            for (const [key, text] of Object.entries(customBlocksMenuLinkTitles ?? {})) {
                linkText = text;
            }
        }

        return { href: href, text: linkText };
    });

    if (!Array.isArray(links)) {
        console.warn("Links is not array!");
        return null;
    }

    const CNMenuLinks = ["menu-links"];
    props.mobile && CNMenuLinks.push("mobile");

    const elProps = toElementProps(props, { className: CNMenuLinks });
    return (
        <div {...elProps}>
            {links?.map(
                ({ href, text }) =>
                    text && (
                        <a key={href} className="menu-link link ignore-global" href={href}>
                            {text ?? "MenuLink"}
                        </a>
                    )
            )}
        </div>
    );
}
